// DB module format
export interface StorageProtectionModule {
  icap: StorageProtectionIcapSection;
  exclusions: StorageProtectionExclusionsSection;
}

export interface StorageProtectionIcapSection {
  enabled: boolean;
  serviceName: string;
  enablePort: boolean;
  listenPort: number;
  enableSslPort: boolean;
  listenSslPort: number;
  archiveScan: {
    enabled: boolean;
    archiveMaxSize: number;
    archiveMaxDepth: number;
  };
  congestionControl: {
    mode: number;
    maxConnections: number;
  };
  scanAction: {
    defaultAction: number;
  };
}

export interface StorageProtectionExclusionsSection {
  enabled: boolean;
  exclusionItems: StorageProtectionExclusionItem[];
}

export interface StorageProtectionExclusionItem extends StorageProtectionExclusionItemFormValue {
  idRelative: string;
}

// UI form value format
export interface StorageProtectionExclusionItemFormValue {
  type: StorageExclusionItemType;
  path: string;
  description: string;
}

// enums for ui settings
export enum CongestionControl {
  DROP_WHEN_SVA_IS_OVERLOADED = 1,
  RESTRICT_MAX_CONNECTIONS = 2,
}
export enum ScanActions {
  DENY_ACCESS = 1,
  DISINFECT = 2,
}
export enum StorageExclusionItemType {
  HASH = 1,
  WILDCARD = 2,
}
